import { useReduxState } from 'hooks';
import { Checkbox, FormGroup, NumberStepper } from 'components/common/form';
import { SiteSettingsForm } from '.';

const SiteSettingsLoginSettings = () => {
  const {
    messages,
    serverConfig: {
      authAllowPasswordSetForSsoUser,
      authDisableLocalLoginIfSso,
      authEnableLocalLogin,
      authForceAdminSso,
      loginShowPreviousLoginNotification,
      loginLockAfterFailedAttempts,
      loginLockTemporarilyInMinutes,
      passwordDoNotForcePasswordChange,
      passwordDisallowWeakPasswords,
      passwordMaximumLength,
      passwordMinimumLength,
      passwordPreventFiveLastPasswords,
      passwordRequireLettersAndNumeral,
      passwordExpirationSendReminders,
      passwordExpirationTimeInDays,
      passwordManuallySetExpirationTimeInDays
    }
  } = useReduxState();

  const initialValues = {
    authAllowPasswordSetForSsoUser,
    authDisableLocalLoginIfSso,
    authEnableLocalLogin,
    authForceAdminSso,
    loginShowPreviousLoginNotification,
    loginLockAfterFailedAttempts,
    loginLockTemporarilyInMinutes,
    passwordDoNotForcePasswordChange,
    passwordDisallowWeakPasswords,
    passwordMaximumLength,
    passwordMinimumLength,
    passwordPreventFiveLastPasswords,
    passwordRequireLettersAndNumeral,
    passwordExpirationSendReminders,
    passwordExpirationTimeInDays,
    passwordManuallySetExpirationTimeInDays
  };

  return (
    <SiteSettingsForm initialValues={initialValues} title="Login settings">
      {(formState) => (
        <div>
          <FormGroup label="Local login">
            <Checkbox
              field="authEnableLocalLogin"
              id="auth-enable-local-login"
              label="Enable local login"
            />
          </FormGroup>

          <FormGroup label="Login notification">
            <Checkbox
              field="loginShowPreviousLoginNotification"
              id="login-show-previous-login-notification"
              label={messages.siteSettingsLoginShowPreviousLoginNotification}
            />
          </FormGroup>

          <FormGroup label="Failed logins">
            <NumberStepper
              field="loginLockAfterFailedAttempts"
              id="login-lock-after-failed-attempts"
              label={messages.siteSettingsLoginLockAfterFailedAttempts}
              min={0}
              stepValue={1}
              style={{ marginTop: 5 }}
            />

            <NumberStepper
              field="loginLockTemporarilyInMinutes"
              id="login-lock-temporarily-in-minutes"
              label={messages.siteSettingsLoginLockTemporarilyInMinutes}
              min={0}
              stepValue={1}
              style={{ marginTop: 10 }}
            />
          </FormGroup>

          <FormGroup label="SSO login enabled">
            <Checkbox
              disabled={formState.values.authAllowPasswordSetForSsoUser}
              field="authDisableLocalLoginIfSso"
              id="auth-disable-local-login-if-sso"
              label="Disable local login if sso is active"
            />

            <Checkbox
              disabled={formState.values.authDisableLocalLoginIfSso}
              field="authAllowPasswordSetForSsoUser"
              id="auth-allow-password-set-for-sso-user"
              label="Allow SSO user to set password"
              style={{ marginTop: 5 }}
            />

            <Checkbox
              field="authForceAdminSso"
              id="auth-force-admin-sso"
              label={messages.siteSettingsForceAdminSso}
              style={{ marginTop: 5 }}
            />
          </FormGroup>

          <FormGroup label={messages.commonPassword}>
            <NumberStepper
              field="passwordMaximumLength"
              id="password-maximum-length"
              label={messages.siteSettingsPasswordMaximumLength}
              min={0}
              stepValue={1}
            />

            <NumberStepper
              field="passwordMinimumLength"
              id="password-minimum-length"
              label={messages.siteSettingsPasswordMinimumLength}
              min={0}
              stepValue={1}
              style={{ marginTop: 10 }}
            />

            <Checkbox
              field="passwordDisallowWeakPasswords"
              id="password-disallow-weak-passwords"
              label={messages.siteSettingsPasswordDisallowWeakPasswords}
              style={{ marginTop: 10 }}
            />

            <Checkbox
              field="passwordRequireLettersAndNumeral"
              id="password-require-letters-and-numeral"
              label={messages.siteSettingsPasswordRequireLettersAndNumeral}
              style={{ marginTop: 10 }}
            />

            <Checkbox
              field="passwordPreventFiveLastPasswords"
              id="password-prevent-five-last-passwords"
              label={messages.siteSettingsPasswordPreventFiveLastPasswords}
              style={{ marginTop: 10 }}
            />

            <NumberStepper
              field="passwordExpirationTimeInDays"
              id="password-expiration-time-in-days"
              label={messages.siteSettingsPasswordExpirationTimeInDays}
              min={0}
              stepValue={1}
              style={{ marginTop: 20 }}
            />

            <NumberStepper
              disabled={formState.values.passwordDoNotForcePasswordChange}
              field="passwordManuallySetExpirationTimeInDays"
              id="password-manually-set-expiration-time-in-days"
              label={
                messages.siteSettingsPasswordManuallySetExpirationTimeInDays
              }
              min={1}
              stepValue={1}
              style={{ marginTop: 10 }}
            />

            <Checkbox
              field="passwordDoNotForcePasswordChange"
              id="password-avoid-manual-password-reset"
              label={messages.siteSettingsPasswordDoNotForcePasswordChange}
              style={{ marginTop: 10 }}
            />

            <Checkbox
              field="passwordExpirationSendReminders"
              id="password-expiration-send-reminders"
              label={messages.siteSettingsPasswordExpirationSendReminders}
              style={{ marginTop: 10 }}
            />
          </FormGroup>
        </div>
      )}
    </SiteSettingsForm>
  );
};

export default SiteSettingsLoginSettings;
